import { render, staticRenderFns } from "./LivingOptionsProperties.vue?vue&type=template&id=e560016e"
import script from "./LivingOptionsProperties.vue?vue&type=script&lang=js"
export * from "./LivingOptionsProperties.vue?vue&type=script&lang=js"
import style0 from "./LivingOptionsProperties.vue?vue&type=style&index=0&id=e560016e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports